// extracted by mini-css-extract-plugin
module.exports = {"container":"_1kvlqWGSxQG6EyGF_YQpx0"};